
import Articles from "~/assets/blog.json";

export default {
  props: {
    isNewsletter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      articles: Articles,
      path: this.$route.path,
      dataPrefill: "",
    };
  },

  computed: {
    article() {
      return this.articles.find((x) =>
        "/blog/" + x.url === this.path ? x : null
      );
    },

    imgHero() {
      return require("~/assets/img/blog/" + this.article.image);
    },
  },

  mounted() {
    this.generateIds();
    const q = this.$route.query || {};
    const pageUrl = window.location.origin + this.$route.fullPath;
    const enc = encodeURIComponent;
    this.dataPrefill =
      `page_url=${enc(pageUrl)}` +
      `&utm_source=${enc(q.utm_source || "")}` +
      `&utm_medium=${enc(q.utm_medium || "")}` +
      `&utm_campaign=${enc(q.utm_campaign || "")}` +
      `&utm_content=${enc(q.utm_content || "")}` +
      `&sc=${enc(q.sc || "")}` +
      `&utm_term=${enc(q.utm_term || "")}` +
      `&id_form1=${enc(q.submissionid || q.invitee_uuid || "")}` +
      `&email=${enc(q.email || q.invitee_email || "")}` +
      `&telephone=${enc(q.telephone || q.answer_1 || "")}` +
      `&name=${enc(q.nom || q.invitee_last_name || "")}`;
  },

  methods: {
    generateIds() {
      const hseconds = document.querySelectorAll(".content h2");
      hseconds.forEach((h2, i) => {
        h2.id = this.article.summary[i].slug;
      });
    },

    scrollSmooth() {
      document.documentElement.style.scrollBehavior = "smooth";
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = "unset";
      }, 1000);
    },
  },
};
